/**
 * Keep the admin's compact text fields separate from the API's structured arrays.
 *
 * Scientific citations contain commas, so they deliberately use line boundaries while
 * tags and search keywords use comma separation.
 */

/** Parse a comma-separated editor field, trimming and de-duplicating values. */
export function parseCommaSeparated(value: string): string[] {
  return uniqueValues(value.split(","));
}

/** Parse references one line at a time; commas inside citations stay intact. */
export function parseLineSeparated(value: string): string[] {
  return uniqueValues(value.split(/\r?\n/));
}

/** Present stored tag or keyword values in a compact editable field. */
export function formatCommaSeparated(values: readonly string[]): string {
  return values.join(", ");
}

/** Present stored citations with one complete reference per editable line. */
export function formatLineSeparated(values: readonly string[]): string {
  return values.join("\n");
}

function uniqueValues(values: string[]): string[] {
  return [...new Set(values.map((value) => value.trim()).filter(Boolean))];
}
